import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import { adminPageWrap } from '../styles/adminPageShell';
import { TalentPoolDictSection } from '../components/data-dict/TalentPoolDictSection';
import { EvalRolesSection } from '../components/data-dict/EvalRolesSection';
import { CompetencyItemsSection } from '../components/data-dict/CompetencyItemsSection';

const DICT_TABS = ['talent-pools', 'eval-roles', 'competency-items'] as const;
type DictTab = (typeof DICT_TABS)[number];

function parseDictTab(raw: string | null): DictTab {
  if (raw && DICT_TABS.includes(raw as DictTab)) return raw as DictTab;
  return 'talent-pools';
}

/** 素质项评价 · 数据字典（人才池、评价角色、素质项等租户级可维护项） */
export function DataDictionaryPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = parseDictTab(searchParams.get('tab'));

  return (
    <div style={adminPageWrap}>
      <div className="tg-page-title">数据字典</div>
      <p style={{ color: '#666', fontSize: 13, marginBottom: 16, maxWidth: 720 }}>
        维护全站引用的基础数据：人才池名称、评价角色、素质项等。修改后相关页面刷新即可生效。
      </p>
      <Tabs
        activeKey={tab}
        onChange={(key) => setSearchParams({ tab: key })}
        items={[
          {
            key: 'talent-pools',
            label: '人才池',
            children: <TalentPoolDictSection />,
          },
          {
            key: 'eval-roles',
            label: '评价角色',
            children: <EvalRolesSection />,
          },
          {
            key: 'competency-items',
            label: '素质项',
            children: <CompetencyItemsSection />,
          },
        ]}
      />
    </div>
  );
}
